import { isCustomProduct, state } from '../store/state'
import elements from '../store/elements'

const formData = () => {
  const ret = {
    id: state.variant.id,
    quantity: (function () {
      if (isCustomProduct) {
        const propsInput = document.querySelector('#propertiesOfSet')
        if (propsInput !== null) {
          const value = JSON.parse(propsInput.value)
          if (value instanceof Array) {
            return value.length
          }
        }
      }
      return 1
    }()),
    properties: {}
  }

  // add props:
  elements.form.querySelectorAll('input[type="hidden"][name*="properties"], input[type="radio"][name*="properties"]:checked').forEach(elem => {
    ret.properties[elem.name.slice(elem.name.indexOf('[') + 1, elem.name.lastIndexOf(']'))] = elem.value
  })

  return ret
}

const addAjax = () => {
  elements.form.addEventListener('submit', event => {
    event.preventDefault()

    elements.addButton.classList.add('loading')

    const queryData = formData()

    window.$.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: queryData,
      success: function (itemData) {
        // addModal.show(itemData)
        elements.addButton.classList.remove('loading')
        queryData.itemData = itemData
        document.dispatchEvent(new window.CustomEvent('addToCart', {
          detail: queryData
        }))
      }
    })
  })
}

export default addAjax
